module.exports = __webpack_public_path__ + "static/SharePortal-c34598995e8d2a0a4ed42f285f08bc0a.png";